var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6335 22.5598C21.1185 22.5598 24.0002 19.7139 24.0002 16.2799C24.0002 12.8522 21.1121 10 17.6271 10C14.4053 10 11.7033 12.4348 11.3118 15.502C11.4786 15.502 11.6391 15.5147 11.7995 15.54C11.9985 15.5653 12.1974 15.6095 12.39 15.6665C12.6916 13.0799 14.9123 11.0751 17.6271 11.0751C20.5601 11.0751 22.9091 13.3961 22.9156 16.2799C22.9156 17.6269 22.4085 18.8412 21.5742 19.7645C20.6051 18.9677 19.1546 18.4364 17.6271 18.4364C16.9083 18.4364 16.0932 18.5882 15.3359 18.8538C15.3808 19.0942 15.4065 19.3408 15.4065 19.5874C15.4065 20.4159 15.1433 21.1938 14.7005 21.8452C15.5797 22.2942 16.581 22.5598 17.6335 22.5598ZM17.6267 17.3486C18.859 17.3486 19.7896 16.2988 19.7896 14.9771C19.7896 13.7312 18.8398 12.6498 17.6267 12.6498C16.4202 12.6498 15.4639 13.7312 15.4639 14.9771C15.4639 16.2988 16.4009 17.3486 17.6267 17.3486ZM11.2604 22.8001C13.0317 22.8001 14.5207 21.3456 14.5207 19.5875C14.5207 17.8293 13.051 16.3748 11.2604 16.3748C9.47615 16.3748 8 17.8293 8 19.5875C8 21.3582 9.47615 22.8001 11.2604 22.8001ZM11.2669 21.6744C11.0423 21.6744 10.8433 21.5227 10.8433 21.2823V19.9732H9.61746C9.39925 19.9732 9.21955 19.7962 9.21955 19.5875C9.21955 19.3724 9.39925 19.1954 9.61746 19.1954H10.8433V17.8863C10.8433 17.6523 11.0423 17.5005 11.2669 17.5005C11.4851 17.5005 11.6841 17.6523 11.6841 17.8863V19.1954H12.9099C13.1281 19.1954 13.3014 19.3724 13.3014 19.5875C13.3014 19.7962 13.1281 19.9732 12.9099 19.9732H11.6841V21.2823C11.6841 21.5227 11.4851 21.6744 11.2669 21.6744Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUsers);
export default __webpack_public_path__ + "static/media/AddUsers.4b784a26469eda8abd4028168f57e12a.svg";
export { ForwardRef as ReactComponent };